module.exports = __webpack_public_path__ + "img/logomarca2.61172c13.png";